import { gql } from '@apollo/client'

export const endChapterAssessmentsMutation = gql`
  mutation EndChapterAssessments ($companyId: String!, $courseId: String!, $chapterId: String!) {
    endChapterAssessments (companyId: $companyId, courseId: $courseId, chapterId: $chapterId)
  }
`
